module.exports = __webpack_public_path__ + "img/second.d57cc25d.jpg";